import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function SearchButton(_ref) {
  var disabled = _ref.disabled,
      isLoading = _ref.isLoading;

  var renderButton = /*#__PURE__*/_jsxs(Button, {
    type: "submit",
    disabled: disabled,
    className: "width-max",
    children: [/*#__PURE__*/_jsx(Search, {
      className: "icon"
    }), /*#__PURE__*/_jsx("span", {
      className: "ml-2 d-inline d-md-none d-lg-inline",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "form.search"
      })
    })]
  });

  var renderTooltip = /*#__PURE__*/_jsx(Tooltip, {
    id: "submit-warning",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      id: "form.search_disabled_tooltip"
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [disabled && !isLoading && /*#__PURE__*/_jsx(OverlayTrigger, {
      placement: "top",
      delay: {
        hide: 200
      },
      overlay: renderTooltip,
      children: /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          zIndex: 2
        }
      })
    }), renderButton]
  });
}
SearchButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};